export default {
  RV: 'rv',
  MARINE: 'marine',
  POWERSPORTS: 'powersport',
  AUTO: 'auto',
};
